var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003675_11661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4432 3.12061H14.1758V11.1106H37.5582V7.23402C37.5582 4.96567 35.7122 3.12061 33.4432 3.12061Z",
    fill: "#A1B8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z",
    fill: "#12437C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 13.9999V37.8812C42 40.1525 40.1511 41.9998 37.8789 41.9998H4.12111C1.84891 41.9998 0 40.1525 0 37.8812V9.88037H37.8789C40.1511 9.88037 42 11.7283 42 13.9999Z",
    fill: "#154D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 13.9999V37.8812C42 40.1525 40.1511 41.9998 37.8789 41.9998H21V9.88037H37.8789C40.1511 9.88037 42 11.7283 42 13.9999Z",
    fill: "#12437C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.049 25.94C32.049 32.0325 27.0928 36.9889 21.0011 36.9889C14.9093 36.9889 9.95312 32.0325 9.95312 25.94C9.95312 19.8486 14.9093 14.8921 21.0011 14.8921C27.0928 14.8921 32.049 19.8486 32.049 25.94Z",
    fill: "#E8EDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 25.94C32.0479 32.0325 27.0918 36.9889 21 36.9889V14.8921C27.0918 14.8921 32.0479 19.8486 32.0479 25.94Z",
    fill: "#A1B8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5593 26.0753C24.3289 26.2704 24.0466 26.3656 23.7668 26.3656C23.4166 26.3656 23.0686 26.2173 22.8251 25.9282L22.2287 25.2213V29.8494C22.2287 30.5287 21.6776 31.0799 20.9983 31.0799C20.3189 31.0799 19.7678 30.5287 19.7678 29.8494V25.2213L19.1715 25.9282C18.7325 26.4476 17.9567 26.514 17.4373 26.0753C16.9182 25.6373 16.8515 24.8612 17.2896 24.3418L19.7252 21.4543C20.0427 21.0788 20.5061 20.8628 20.9983 20.8628C21.4905 20.8628 21.9538 21.0788 22.2714 21.4543L24.707 24.3418C25.145 24.8612 25.0784 25.6373 24.5593 26.0753Z",
    fill: "#4F79AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.0753C24.3306 26.2704 24.0483 26.3656 23.7686 26.3656C23.4183 26.3656 23.0703 26.2173 22.8268 25.9282L22.2305 25.2213V29.8494C22.2305 30.5287 21.6793 31.0799 21 31.0799V20.8628C21.4922 20.8628 21.9555 21.0788 22.2731 21.4543L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0753Z",
    fill: "#12437C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003675_11661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.0e81044cc9e1e4f5a656b65c75781b49.svg";
export { ForwardRef as ReactComponent };